import React from 'react';
import Home from '@screens/Home';
import SpaCoverOverview from 'src/ui/screens/SpaCover/SpaCoverOverview';
import SafetyCoverOverview from '@screens/SafetyCover/SafetyCoverOverview';
import SpaCoverTechSpecs from '@screens/SpaCover/SpaCoverTechSpecs';
import SafetyCoverTechSpecs from '@screens/SafetyCover/SaferyCoverTechSpecs';
import WarrantyRegistrationForm from '@screens/WarrantyRegistrationForm';
import WarrantyClaim from '../ui/components/WarrantyClaim/WarrantyClaim';
import Login from '../ui/components/Login/Login';
import SpaCoverSummary from '../ui/components/SpaCoverSummary/SpaCoverSummary';
import DealerCreditApplication from '../ui/components/DealerCreditApplication/DealerCreditApplication';
import EmployeeIntakeForm from '../ui/components/EmployeeIntakeForm/EmployeeIntakeForm';

export interface RoutesInterface {
    path: string;
    name: string;
    element: React.FunctionComponent;
}

const appRoutes: RoutesInterface[] = [
    {
        path: '/',
        name: 'Home',
        element: Home
    },
    {
        path: '/spaCoverOverview',
        name: 'Spa Cover',
        element: SpaCoverOverview
    },
    {
        path: '/spaCoverTechSpecs',
        name: 'Spa Cover Tech Specs',
        element: SpaCoverTechSpecs
    },
    {
        path: '/safetyCoverOverview',
        name: 'Safety Cover',
        element: SafetyCoverOverview
    },
    {
        path: '/safetyCoverTechSpecs',
        name: 'Safety Cover Tech Specs',
        element: SafetyCoverTechSpecs
    },
    {
        path: '/warrantyRegistrationForm',
        name: 'Warranty Registration Form',
        element: WarrantyRegistrationForm
    },
    {
        path: '/WarrantyClaim',
        name: 'Warranty Claim',
        element: WarrantyClaim
    },
    {
        path: '/DealerCreditApplication',
        name: 'DealerCreditApplication',
        element: DealerCreditApplication
    },
    {
        path: '/SpaCoverSummary',
        name: 'SpaCoverSummary',
        element: SpaCoverSummary
    },
    {
        path: '/EmployeeIntakeForm',
        name: 'EmployeeIntakeForm',
        element: EmployeeIntakeForm
    },
    {
        path: '/Login',
        name: 'Login',
        element: Login
    }
    
    
 

];

export default appRoutes;
 